<template lang="html">
  <div v-show="!emailListSubscribed">
    <h4>Get project updates</h4>
    <p>New tools will launch soon. Sign up to be notified.</p>
    <form
      action="https://Soundslides.us20.list-manage.com/subscribe/post"
      method="POST"
    >
      <input type="hidden" name="u" value="df4fe535b5b280b9e612b5c41" />
      <input type="hidden" name="id" value="19ccefc741" />
      <b-form-group
        id="exampleInputGroup3"
        description="We'll never share your email with anyone else."
      >
        <b-form-input
          id="MERGE0"
          type="email"
          placeholder="Enter your email address"
          autocapitalize="off"
          autocorrect="off"
          name="MERGE0"
          size="25"
          value=""
        />
      </b-form-group>
      <input
        type="submit"
        class="btn btn-primary mt-2"
        name="submit"
        value="Join notifications list"
      />
    </form>
  </div>
</template>

<script>
export default {
  name: "EmailListSignup",
  computed: {
    emailListSubscribed() {
      // Too clever for now.
      // if (this.$store.state.user_doc.loaded) {
      //   return this.$store.state.user_doc.emailListSubscribed;
      // }
      // return false;
      return false;
    }
  }
};
</script>

<style lang="css" scoped></style>
